// extracted by mini-css-extract-plugin
export var aboveInput = "_nj-0";
export var actionButton = "_nj-5";
export var actionButtonContainer = "_nj-1";
export var actionIcon = "_nj-6";
export var aiInfoContainer = "_nj-2";
export var attachmentWrapper = "_nj-7";
export var bold = "_nj-3";
export var checkIcon = "_nj-8";
export var clickingRecipientBar = "_nj-11";
export var commentThreadSwitch = "_nj-a";
export var draftImage = "_nj-b";
export var draftImageContainer = "_nj-c";
export var draftImages = "_nj-e";
export var editButton = "_nj-g";
export var editor = "_nj-f";
export var editorContainer = "_nj-y";
export var editorErrorTooltipWrapper = "_nj-9";
export var headerDivider = "_nj-h";
export var icon = "_nj-i";
export var info = "_nj-j";
export var internal = "_nj-n";
export var internalDivider = "_nj-k";
export var internalMessage = "_nj-l";
export var messageInputCard = "_nj-m";
export var messageInputForm = "_nj-o";
export var messageInputFormInternal = "_nj-p";
export var options = "_nj-q";
export var publicMessageCustomer = "_nj-s";
export var publicMessageMerchant = "_nj-r";
export var removeImageButton = "_nj-d";
export var replyButtons = "_nj-t";
export var showSignatureButton = "_nj-u";
export var spinner = "_nj-v";
export var verticalButtonDivider = "_nj-4";
export var visibilitySelector = "_nj-w";
export var warning = "_nj-x";
export var wrappingText = "_nj-z";
export var writingInternalNoteTopBorder = "_nj-10";